import { Swiper, SwiperSlide } from "swiper/react";

import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import CommentCard from "@/components/cards/CommentCard/CommentCard.tsx";
import Section from "@/components/helpers/Section/Section.tsx";

import { ROUTES } from "@/config/routes.ts";
import { useGetCommentsList } from "@/hooks/api/feed.hooks";
import { cn } from "@/utils/cn";

import DetailRateForm from "./DetailRateForm";

interface RateAndComments {
  comment: string;
}

const RateAndComments = (): JSX.Element => {
  const { t } = useTranslation();
  const { id } = useParams() as { id: string };
  const { data } = useGetCommentsList(+id, 18);

  const filtered = data.pages[0].results.filter((a) => a.text);

  return (
    <Section
      link={ROUTES.DETAIL.COMMENTS.replace(":id", id)}
      title={t("General.rate-and-reviews")}
      className={cn({
        "hidden md:block": filtered.length == 0,
      })}
    >
      <div className={"flex items-stretch gap-5 pt-6 max-2xl:items-start max-md:flex-col max-md:pt-2 "}>
        <div className="hidden md:block">
          <DetailRateForm />
        </div>
        {/* {filteredSlice && (
          <div
            className={"hidden flex-1 grid-cols-2 gap-5 max-2xl:w-full max-2xl:grid-cols-1 md:grid xl:h-[18.4375rem]"}
          >
            {filteredSlice.map((comment) => (
              <CommentCard
                key={comment.id}
                isFull={!(comment.text?.length > 100)}
                text={comment.text}
                user={comment.name}
                time={comment.updated_at}
                rating={comment.rating}
              />
            ))}
          </div>
        )} */}
        {filtered && (
          <div className="h-full w-full overflow-hidden ">
            <Swiper
              slidesPerView={1}
              slidesPerGroup={1}
              spaceBetween={8}
              mousewheel={{
                forceToAxis: true,
              }}
              speed={500}
              modules={[]}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  slidesPerGroup: 1,
                  spaceBetween: 10,
                },
                1284: {
                  slidesPerView: 2,
                  slidesPerGroup: 2,
                  spaceBetween: 12,
                },
              }}
              className={"h-[20.625rem] max-xl:h-[19.0625rem] max-md:h-auto"}
            >
              {filtered.map((comment) => {
                return (
                  <SwiperSlide key={comment.id}>
                    <CommentCard
                      key={comment.id}
                      text={comment.text}
                      user={comment.name}
                      rating={comment.rating}
                      time={comment.updated_at}
                      isFull={!(comment.text?.length > 100)}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )}
      </div>
    </Section>
  );
};

export default RateAndComments;
